exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".normalBlock-fc5cd999{width:80vw;max-width:900px;margin-left:auto;margin-right:auto}@media screen and (max-width: 500px){.normalBlock-fc5cd999{margin-left:20px;margin-right:20px;min-width:300px;width:auto}}.textBlock-68d0f734{width:80vw;max-width:900px;margin-left:auto;margin-right:auto;max-width:750px}@media screen and (max-width: 500px){.textBlock-68d0f734{margin-left:20px;margin-right:20px;min-width:300px;width:auto}}.bigBlock-efaa3e36{width:100%;min-width:300px;margin:0 0}\n", ""]);

// Exports
exports.locals = {
	"normalBlock": "normalBlock-fc5cd999",
	"textBlock": "textBlock-68d0f734",
	"bigBlock": "bigBlock-efaa3e36"
};